import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);

  width: 100%;
  min-height: 300px;
  padding: 30px 25px 40px;
  margin-bottom: 10px;
  text-align: center;

  > strong {
    text-align: center;
    font-size: 18px;
    color: ${props => props.theme.colors.primary};

    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
  }

  span {
    margin-bottom: 15px;
  }

  small {
    margin-top: 12px;
    width: 90%;
  }

  @media screen and (max-width: 766px) {
    padding: 30px 15px;
  }
`
